import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useMemo } from "react";
import RemoteComponent from "../../components/RemoteComponent";
import { useHostMicroFrontendApi } from "../../shared/microfrontend/hooks/useHostMicroFrontend";
import Lottie from "react-lottie-player";
import LoadingAnimationHands from "@/assets/animations/loadingAnimationHands.json";
import { useMainLayoutStore } from "@/shared/zustand/mainLayoutStore";
export const WidgetsWrapper = ({ 
// activeMode,
// isRemoteLoaded, // not used anywhere
// setIsRemoteLoaded, // old code
setRemoteLoadedInfo, 
// modeList,
hasProject, }) => {
    const { modeFullScreen, activeMode, modeList } = useMainLayoutStore();
    // const showToast = useToastStore((state) => state.showToast);
    const [loadError, setLoadError] = useState(null);
    const mfApi = useHostMicroFrontendApi();
    const [key, setKey] = useState(0); // Add this to force remount
    useEffect(() => {
        // Reset state when mode changes
        setLoadError(null);
        // setIsRemoteLoaded(false); // old code
        setRemoteLoadedInfo({ modeName: activeMode, isLoaded: false });
        setKey((prev) => prev + 1); // Force remount of RemoteComponent
    }, [activeMode]);
    const handleRemoteLoad = () => {
        console.log("[WidgetsWrapper] Remote component loaded successfully:", activeMode);
        // setIsRemoteLoaded(true); // old code
        // setRemoteLoadedInfo({ modeName: activeMode, isLoaded: true }); // commented here as now its being taken by remoteReadyUnsubscribe
        setLoadError(null);
        if (mfApi && "setRemoteLoaded" in mfApi) {
            mfApi.setRemoteLoaded(true);
        }
    };
    const handleRemoteError = (error) => {
        console.error("[WidgetsWrapper] Failed to load remote component:", error);
        setLoadError(error.message);
        // setIsRemoteLoaded(false); // old code
        setRemoteLoadedInfo({ modeName: activeMode, isLoaded: false });
        if (mfApi && "setRemoteLoaded" in mfApi) {
            mfApi.setRemoteLoaded(false);
        }
    };
    const activeData = useMemo(() => {
        const matchingWidget = modeList.find((widget) => widget.modeName === activeMode);
        if (matchingWidget) {
            return {
                url: matchingWidget.url.replace(/\/$/, ""), // Remove trailing slash if present
                remote: matchingWidget.remote,
                module: matchingWidget.module,
            };
        }
        return undefined;
    }, [activeMode, modeList]);
    return (_jsx("div", { className: `w-full h-full ${modeFullScreen ? "fixed inset-0 z-50 bg-white" : ""}`, children: activeMode ? (_jsx("div", { className: "w-full h-full overflow-auto", children: _jsx("div", { className: `relative ${modeFullScreen ? "h-screen" : "h-full overflow-auto"}`, children: _jsx(React.Suspense, { fallback: _jsx(Lottie, { animationData: LoadingAnimationHands, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }), children: loadError ? (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "text-center text-red-500 py-10", children: [_jsx("p", { children: "Failed to load remote component:" }), _jsx("p", { children: loadError })] }) })) : (_jsx(_Fragment, { children: activeMode &&
                            activeData?.url &&
                            activeData?.remote &&
                            activeData?.module ? (_jsx(RemoteComponent, { url: activeData.url, scope: activeData.remote, module: activeData.module, onLoad: handleRemoteLoad, onError: handleRemoteError }, key)) : (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "text-center text-red-500 py-10", children: [_jsx("p", { children: "Don't have proper data for the mode" }), _jsx("p", { children: JSON.stringify(activeData) })] }) })) })) }) }) })) : (_jsx("p", { className: "text-center py-10", children: "No content to show" })) }));
};
